export class AsignacionMasivaBloqueDto {
  existe: boolean;
  blockId: number;
  blockLabelId: number;
  periodoId: number;
  campusId: number;
  grupos: number[];
  alumnos: number[];
}
